module.exports = __webpack_public_path__ + "static/media/noun_Clothes_3460964.3bd9dbcd.png";